import React, { useEffect, useState } from "react";
import AcademyHead from "./AcademyHead";
// import { FaFacebookF, FaYoutube } from "react-icons/fa";
// import { IoLocationSharp } from "react-icons/io5";
import { BsCalendar2DateFill } from "react-icons/bs";
import Spinner from "../../components/spinner/Spinner";
import { useParams } from "react-router-dom";
import { getFetcher } from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";
import { toast } from "react-toastify";
import { parseStatics } from "../../function/parseStatics";

interface IEvent {
  id?: string;
  title: string;
  firstText: string;
  secondText: string;
  images: string[];
  videoLink: string;
  companyName: string;
  companyPhone: string;
  companyEmail: string;
  companyAddress: string;
  companyLogo: string;
  companyAbout: string;
  endDate: string;
  status?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

const AcademyEventsDetail: React.FC = () => {
  const { id } = useParams();
  const [showImageModal, setShowImageModal] = useState<boolean>(false);
  const [selectedImage, setSelectedImage] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [event, setEvent] = useState<IEvent>();
  const [parsedImages, setParsedImages] = useState<string[]>([]);

  useEffect(() => {
    const getSingleEvent = async () => {
      setLoading(true);
      try {
        const response = await getFetcher(
          endpoints.eAcademy.getSingleEvent.replace("{eventId}", id || "")
        );

        if (response.result) {
          setEvent(response.event);
          setParsedImages(parseStatics(response.event.images));
          setTimeout(() => {
            setLoading(false);
          }, 200);
        } else {
          toast.error("Error");
        }
      } catch (error) {
        console.log(error);
      }
    };
    getSingleEvent();
  }, [id]);

  const handleClickImage = (url: string) => {
    setSelectedImage(url);
    setShowImageModal(true);
  };

  useEffect(() => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    }, 300);
  }, []);

  if (loading)
    return (
      <div>
        <Spinner />
      </div>
    );

  return (
    <div className="flex flex-col gap-y-5 px-2">
      {/* HEAD */}
      <div>
        <AcademyHead title={"ECZA AKADEMİ ETKLİNLİK DETAY"} />
      </div>

      {/* EVENT */}
      <div className="container mx-auto px-4 py-4 rounded-xl border-gray-300">
        <div className="bg-white shadow-xl rounded-lg overflow-hidden">
          {/* Event Image */}
          <div className="relative w-full h-64 sm:h-80 md:h-96 bg-gray-200">
            <img
              src={parsedImages[0]}
              alt={event?.title}
              className="object-cover w-full h-full"
            />
          </div>

          {/* Event Info */}
          <div className="p-4 sm:p-6">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              {event?.title}
            </h1>

            {/* Event Date & Location */}
            <div className="flex flex-col sm:flex-row sm:justify-between items-start sm:items-center mb-6">
              <p className="text-gray-600 text-sm sm:text-base flex items-center gap-x-2">
                <div className="border p-2 rounded-full bg-primary-color text-white">
                  <BsCalendar2DateFill size={20} />
                </div>
                <strong className="font-semibold">Etkinlik Tarihi:</strong>
                <span className="text-gray-700 font-semibold">
                  <span className="text-green-700">
                    {event?.createdAt &&
                      new Date(event?.createdAt).toLocaleDateString("tr-TR", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                  </span>{" "}
                  -{" "}
                  <span className="text-red-700">
                    {event?.endDate &&
                      new Date(event?.endDate).toLocaleDateString("tr-TR", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                  </span>
                </span>
              </p>
              {/* <p className="text-gray-600 text-sm sm:text-base flex items-center gap-x-2">
            <div className="border p-2 rounded-full bg-primary-color text-white">
              <IoLocationSharp size={20} />
            </div>
            <strong className="font-semibold">Lokasyon:</strong> {event.location}
          </p> */}
            </div>

            {/* Event Description */}
            <div className="space-y-6 mb-8">
              <p className="text-gray-700 leading-relaxed">
                {event?.firstText}
              </p>
            </div>

            {/* Additional Images */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-8">
              {parsedImages.map((imageUrl, index) => (
                <div
                  key={index}
                  className="w-full h-48 overflow-hidden rounded-lg shadow-md cursor-pointer transition-transform duration-300 transform hover:scale-105"
                  onClick={() => handleClickImage(imageUrl)}
                >
                  <img
                    src={imageUrl}
                    alt={`Additional Image ${index + 1}`}
                    className="object-cover w-full h-full"
                  />
                </div>
              ))}
            </div>

            {/* Event Description */}
            <div className="space-y-6 my-8">
              <p className="text-gray-700 leading-relaxed">
                {event?.secondText}
              </p>
            </div>

            {/* Video Section */}
            <div className="mt-8 h-64 sm:h-80">
              <iframe
                src={`https://www.youtube.com/embed/${
                  event?.videoLink.split("v=")[1]
                }`}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full rounded-lg shadow-md"
              ></iframe>
            </div>
          </div>

          {/* Company Info */}
          <div className="p-4 sm:p-6 border-t border-gray-200 flex flex-col sm:flex-row">
            <div className="flex flex-col sm:flex-row items-center sm:items-start flex-1 border-b sm:border-b-0 sm:border-r pb-4 sm:pb-0">
              <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full overflow-hidden shadow-md mb-4 sm:mb-0">
                <img
                  src={event?.companyLogo}
                  alt={event?.companyName}
                  className=" object-contain w-full h-full"
                />
              </div>

              <div className="flex-1 sm:ml-6">
                <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">
                  {event?.companyName}
                </h2>
                <div className="space-y-2 mb-4">
                  <p className="text-gray-700">
                    <strong className="font-semibold">Adres:</strong>{" "}
                    {event?.companyAddress}
                  </p>
                  <p className="text-gray-700">
                    <strong className="font-semibold">Telefon:</strong>{" "}
                    {event?.companyPhone}
                  </p>
                  <p className="text-gray-700">
                    <strong className="font-semibold">E-posta:</strong>{" "}
                    <a
                      href={`mailto:${event?.companyEmail}`}
                      className="text-primary-color hover:underline"
                    >
                      {event?.companyEmail}
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <div className="flex-1 sm:px-4">
              <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">
                Firma Hakkında
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {event?.companyAbout}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* IMAGE MODAL */}
      {showImageModal && (
        <div
          onClick={() => setShowImageModal(false)}
          className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50"
        >
          <div
            className="w-full h-full absolute"
            onClick={() => setShowImageModal(false)}
          ></div>

          <div
            className="relative w-full max-w-3xl h-1/2"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              className="w-full h-full rounded-lg object-contain"
              src={selectedImage && selectedImage}
              alt="Full-size Image"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AcademyEventsDetail;
